import { useQuery } from '@tanstack/react-query';
import { publicClient } from '@/api/clients';

export const useHallOfFame = () => {
  return useQuery({
    queryKey: ['hall-of-fame'],
    queryFn: () => publicClient.get('/api/v1/hall-of-fame').then(res => res.data),
    staleTime: 1000 * 60 * 60 * 24 * 7, // 7 days
    gcTime: 1000 * 60 * 60 * 24 * 7,
  });
};